import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';
import UserActivityLogsPage from '@/features/user-activity-logs';

export const Route = createFileRoute('/_authenticated/user-activity-logs')({
  component: () => (
    <ProtectedRoute requiredPermission={Permissions.UserActivityView}>
      <UserActivityLogsPage />
    </ProtectedRoute>
  ),
});
